module.exports = __webpack_public_path__ + "img/plexus-9.fc8a3663.png";